import React from 'react';
import { requestRegistration } from '../../messagebus';

export const RegistrationButton = ({ label }) => {
  return <div className="sb-header__item">
  <button
    className="action-registration__button"
    onClick={requestRegistration}
    data-test-id="@sitebase/registration-button_hrs-action__registration-button"
  >
    {label}
  </button>
</div>
}